import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	gap: var(--spacing-small);
	span {
		cursor: pointer;
	}
	.separator {
		min-height: var(--px-20);
		background-color: var(--neutrals-300);
	}
`;
